var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.user ? _c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('Widget', {
    staticClass: "col-span-2"
  }, [_c('WidgetHeader', [_c('div', {
    staticClass: "flex"
  }, [_vm._v(" Subscription Limits ")])]), _c('WidgetBody', {
    staticClass: "pt-0"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-x-4"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "text-sm font-bold"
  }, [_vm._v("CPA Campaign")]), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('div', [_vm.cpaCampaignRestriction ? _c('div', {
    staticClass: "flex items-center gap-2 text-2xl font-semibold"
  }, [_c('animated-number', {
    attrs: {
      "value": _vm.cpaCampaignRestriction.data.subscribeCount,
      "round": true,
      "duration": 300,
      "easing": "easeOutExpo"
    }
  }), _vm._v(" / "), _c('EditableValue', {
    key: _vm.cpaCampaignRestriction.id,
    attrs: {
      "type": "contentEditable",
      "value": _vm.cpaCampaignRestriction.data.maxSubscriptions,
      "mutation": _vm.UPDATE_PUBLISHER_RESTRICTION_MUTATION,
      "variables": {
        input: {
          id: _vm.cpaCampaignRestriction.id,
          data: {
            maxSubscriptions: '{value}'
          }
        }
      },
      "edit-focus-icon-enabled": false
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "text-blue-600 py-3 font-semibold"
  }, [_vm._v(" Unlimited ")])]), _c('div', {
    staticClass: "text-xs text-gray-500 font-semibold"
  }, [_vm.cpaCampaignRestriction ? [_vm._v(" " + _vm._s(_vm.cpaCampaignRestriction.frequency.toUpperCase()) + " ")] : _vm._e()], 2)]), _c('div', {
    staticClass: "flex items-center justify-end group-hover:opacity-100 opacity-0 transition-opacity duration-300"
  }, [!_vm.cpaCampaignRestriction ? _c('button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.createCampaignRestriction('cpa');
      }
    }
  }, [_c('Icon', {
    staticClass: "text-blue-300 hover:text-blue-600",
    attrs: {
      "name": "plus",
      "size": 6
    }
  })], 1) : _vm._e(), _vm.cpaCampaignRestriction ? _c('button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.removeCampaignRestriction(_vm.cpaCampaignRestriction.id);
      }
    }
  }, [_c('Icon', {
    staticClass: "text-red-300 hover:text-red-600",
    attrs: {
      "name": "close",
      "size": 6
    }
  })], 1) : _vm._e()])])]), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "text-sm font-bold"
  }, [_vm._v("CPL Campaign")]), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('div', [_vm.cplCampaignRestriction ? _c('div', {
    staticClass: "flex items-center gap-2 text-2xl font-semibold"
  }, [_c('animated-number', {
    attrs: {
      "value": _vm.cplCampaignRestriction.data.subscribeCount,
      "round": true,
      "duration": 300,
      "easing": "easeOutExpo"
    }
  }), _vm._v(" / "), _c('EditableValue', {
    key: _vm.cplCampaignRestriction.id,
    attrs: {
      "type": "contentEditable",
      "value": _vm.cplCampaignRestriction.data.maxSubscriptions,
      "mutation": _vm.UPDATE_PUBLISHER_RESTRICTION_MUTATION,
      "variables": {
        input: {
          id: _vm.cplCampaignRestriction.id,
          data: {
            maxSubscriptions: '{value}'
          }
        }
      },
      "edit-focus-icon-enabled": false
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "text-blue-600 py-3 font-semibold"
  }, [_vm._v(" Unlimited ")])]), _c('div', {
    staticClass: "text-xs text-gray-500 font-semibold"
  }, [_vm.cplCampaignRestriction ? [_vm._v(" " + _vm._s(_vm.cplCampaignRestriction.frequency.toUpperCase()) + " ")] : _vm._e()], 2)]), _c('div', {
    staticClass: "flex items-center justify-end group-hover:opacity-100 opacity-0 transition-opacity duration-300"
  }, [!_vm.cplCampaignRestriction ? _c('button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.createCampaignRestriction('cpl');
      }
    }
  }, [_c('Icon', {
    staticClass: "text-blue-300 hover:text-blue-600",
    attrs: {
      "name": "plus",
      "size": 6
    }
  })], 1) : _vm._e(), _vm.cplCampaignRestriction ? _c('button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function ($event) {
        return _vm.removeCampaignRestriction(_vm.cplCampaignRestriction.id);
      }
    }
  }, [_c('Icon', {
    staticClass: "text-red-300 hover:text-red-600",
    attrs: {
      "name": "close",
      "size": 6
    }
  })], 1) : _vm._e()])])])])])], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }